module.exports = __webpack_public_path__ + "img/edit-3.54179a33.svg";